import { Col, Flex, Row, Space } from "antd";
import React from "react";
import { HashLink } from 'react-router-hash-link';
import { MENU } from "../../enums/menu.enum";

export default class Footer extends React.Component {

  menus = [
    {
      label: "Home",
      link: MENU.home
    },
    {
      label: "pdpa",
      link: MENU.pdpa,
    },
    {
      type: "hash-link",
      label: "destination",
      link: "/web#destinations-highlight"
    },
    {
      label: "news and events",
      link: "/web/blogs?type=news_and_events"
    },
    {
      label: "THE SIGNATURE TOURS",
      link: "https://www.thesignaturetours.com/",
      target: "_blank"
    },
    {
      label: "terms & conditions",
      link: MENU.tnc,
    },
    {
      label: "FS HOLIDAYS",
      link: "https://fsholidays.my/home",
      target: "_blank"
    },
    // {
    //   label: "privacy policy",
    //   link: "/web/footer/privacy_policy",
    //   target: "_blank"
    // },
  ]

  componentDidMount() {
    
  }
  
  render(){
    return (
      <div className="footer">
        {/* <Newsletter/> */}

        <div className="footer_body">
          <Row className="footer_links" gutter={[12, 12]}>
            <Col className="column large-column">
              <Space direction="vertical">
                <div className="link-group-items">
                  {
                    this.menus.map((menu, index) => menu.type == "hash-link" ?
                      <HashLink smooth scroll={(el) => el.scrollIntoView({ behavior: 'auto', block: 'end' })} key={index} to={menu.link}> {menu.label} </HashLink> :
                      <a key={index} href={menu.link} target={menu.target}> {menu.label} </a>
                    )
                  }
                </div>
              </Space>
            </Col>
            <Col className="column small-column">
              <Space direction="vertical">
                <div className="link-group-items">
                  <div><a href="/web/about-us">about us</a></div>
                  <div><a href="/web/contact-us">contact us</a></div>
                  {/* <div><a href="/web/agents">agents</a></div> */}
                </div>
              </Space>
            </Col>
            <Col className="column contact-info small-column">
              <Space direction="vertical" align="center">
                <Flex vertical gap="20px" align="center">
                  <div className="link-group-title">Contact Us</div>
                  <div><a href="/web/contact-agents">contact agents</a></div>
                  <div className="link-group-title">Follow us on</div>
                  <Flex gap={20} justify="space-between" className="social-icons">  
                    <a target="_blank" href="https://www.facebook.com/gdgoldendestinations?mibextid=LQQJ4d&rdid=pH2flZqXJ2hEInxM&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2FdyrJrXnkmNiU7ryS%2F%3Fmibextid%3DLQQJ4d#"><img src="/iceholidays-assets/images/social/ico_fb_white.png"/></a>
                    <a target="_blank" href="https://www.youtube.com/@GoldenDestinationsGD"><img src="/iceholidays-assets/images/social/ico_yt_white.png"/></a>
                    {/* <a target="_blank" href="https://wa.me/60128688148"><img src="/iceholidays-assets/images/social/ico_whatsapp.png"/></a> */}
                    <a target="_blank" href="https://www.instagram.com/gdgoldendestinations/?hl=en"><img src="/iceholidays-assets/images/social/ico_ig_white.png"/></a>
                    <a target="_blank" href="https://www.xiaohongshu.com/user/profile/664aaf560000000007007b09?xhsshare=CopyLink&appuid=5ece81090000000001001551&apptime=1723009864&share_id=534e08f2988d425b8466147ee43db45d"><img src="/iceholidays-assets/images/social/xhs_icon.png" style={{height: '18px'}}/></a>
                  </Flex>
                </Flex>
              </Space>
            </Col>
            {/* <Col className="column small-column app-store">
              <Space>
                <a target="_blank" href="/"><img src="/iceholidays-assets/images/social/google_play_icon.png"/></a>
                <a target="_blank" href="https://apps.apple.com/my/app/golden-destinations/id1446862869"><img src="/iceholidays-assets/images/social/app_store_icon.png"/></a>
              </Space>
            </Col> */}
          </Row>
          <div id="copyright">
            <span>Copyright {(new Date().getFullYear())} ICE HOLIDAYS SDN BHD. All Rights Reserved.</span>
          </div>
        </div>

      </div>
    ) 
  }
}